/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import Typewriter from 'typewriter-effect';
import "swiper/css";
import { useHomeSection } from "components/Service/homeSection";

interface SlideItem {
  id: number;
  image: string;
  title: string;
}

const slidesData: SlideItem[] = [
  { id: 1, image: "/images/slide1.jpg", title: "Slide One" },
  { id: 2, image: "/images/slide2.jpg", title: "Slide Two" },
  { id: 3, image: "/images/slide3.jpg", title: "Slide Three" },
];
const UUID = "d74c63f5-7649-47ec-a1a2-e84830d8128a";
const HomeSlider: React.FC = () => {
  const { data, isLoading } = useHomeSection(UUID);
  const [current, setCurrent] = useState<number>(1);
 
  const swiperRef = useRef<SwiperType | null>(null);
 
 const [total, setTotal] = useState<number>(0);

useEffect(() => {
  if (data?.slides?.length) {
    setTotal(data.slides.length);
  }
}, [data]);
  const cleanHtml = (html = "") =>
  html
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const handleSlideClick = () => {
  swiperRef.current?.slideNext();
};
  const [activeIndex, setActiveIndex] = useState(0);
 // console.log(data,'data_home_Slider');

 const [isMobile, setIsMobile] = React.useState(false);

React.useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  handleResize(); // initial check
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);
   if (isLoading) return null; // Suspense will handle skeleton
  if (!data) return null;
  return (
   
      <div className="container-fluid p-0 carousel slide" id="homeSlider">
        <Swiper
          modules={[Navigation, Autoplay]}
          loop
          speed={800}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          slidesPerView={1}
          onSwiper={(swiper: any) => {
            swiperRef.current = swiper;
          }}
          onSlideChange={(swiper: any) => {
            setCurrent(swiper.realIndex + 1); // always use realIndex
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 1 },
          }}
          className="swiper-wrapper"
        >
          {data?.slides.map((slide, index) => (
            <SwiperSlide
              key={slide.sliderid}
              className="swiper-slide home-carousel carousel-video"
            >
              {slide.destop_media?.type === "video" ? (
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  onPlay={() => swiperRef.current?.autoplay.stop()}
                  onEnded={() => swiperRef.current?.autoplay.start()}
                  width="100%"
                  className="w-100"
                   poster={slide?.mobile_media?.url || ""}   // 👈 cover image
                >
                  <source
                    src={slide?.destop_media?.url || ""}
                    type={slide?.destop_media?.mime || ""}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : (
              <img
                        className="img-fluid"
                        src={
                              isMobile
                                ? slide?.mobile_media?.url ?? slide?.destop_media?.url ?? ""
                                : slide?.destop_media?.url ?? ""
                            }
                              alt={
                              isMobile
                                ? slide?.mobile_media?.alt ?? slide?.destop_media?.alt ?? ""
                                : slide?.destop_media?.alt ?? ""
                            }
                       
                        loading="lazy"
                      />
                   
              )}
              <div className="carousel-caption">
                <div className="container home-silder-data fade-in-middle-delay-1">
                  <h3 className=""
                    dangerouslySetInnerHTML={{
                      __html: slide?.slider_title || "",
                    }}
                  />
                  <h2 className="display-2 text-white ">
                    { slide.slider_description
                                ? slide.slider_description.replace(
                                    /<[^>]*>/g,
                                    "",
                                  ) : ''}
                    {/* <Typewriter
                      key={activeIndex}
                      onInit={(typewriter: any) => {
                        typewriter
                          .deleteAll(1) // 🔥 removes previous text instantly
                          .typeString(
                            cleanHtml(
                              slide.slider_description
                                ? slide.slider_description.replace(
                                    /<[^>]*>/g,
                                    "",
                                  )
                                : "",
                            ),
                          )
                          .start();
                      }}
                      options={{
                        delay: 100, // slow typing
                        cursor: "",
                      }}
                    /> */}
                  </h2>
                  <a
                    href={slide?.slider_button_link}
                    className="btn btn-sm btn-primary rounded-pill animated slideInLeft"
                  >
                    {slide?.slider_button_title}
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
   {total > 1 && (
        <div className="container">
          <div id="arrow-counter" className="home-counter-arrow">
            <div className="d-flex justify-content-start align-items-center gap-4 w-100">
              <span
                className="swiper-arrow"
                onClick={() => swiperRef.current?.slidePrev()}
                id="prevSlideshome"
              >
                <i className="bi bi-arrow-left"></i>
              </span>

              <div className="counter fw-semibold">
                {String(current).padStart(2, "0")} /{" "}
                {String(total).padStart(2, "0")}
              </div>

              <span
                className="swiper-arrow"
                onClick={() => swiperRef.current?.slideNext()}
              >
                <i className="bi bi-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
   )}
        {/* Custom Navigation + Counter */}
      </div>
    
  );
};

export default HomeSlider;